<template>
  <div class="main_box">
    <div v-if="!empty" class="big_box">
      <!-- <div class="selcet_bo">
        <el-select size="mini" class="selcet" @change="getAll(index)" v-model="chong_value" placeholder="请选择">
          <el-option v-for="(item, index) in deviceList" :key="item.id" :label="item.deviceName" :value="index"> </el-option>
        </el-select>
      </div> -->
      <div class="center_box">
        <div class="center_text">{{ numericalDevices.deviceName }}</div>
        <div class="center_body">
          <div class="center_">
            <div class="center_img">
              <div class="center_infomation dd">
                <div class="infomation_head">采集的累计脉冲数</div>
                <div class="infomation_body">
                  <span class="status_">脉冲数:</span> <span class="value_">{{ rainGutter == '' ? '--' : rainGutter.realData }}</span>
                </div>
              </div>
              <div class="center_infomation cm">
                <div class="infomation_head">吸气口状态</div>
                <div class="infomation_body">
                  <span class="status_">状态:</span> <span class="value_">{{ lightOperated == '' ? '--' : `${lightOperated.realData}` }}</span>
                </div>
              </div>

              <div class="center_infomation xhtx">
                <div class="infomation_head">采样口状态</div>
                <div class="infomation_body">
                  <div>
                    <span class="status_">状态:</span> <span class="value_">{{ signal == '' ? '--' : `${signal.realData}` }}</span>
                  </div>
                </div>
              </div>
              <div class="center_infomation td">
                <div class="infomation_head">排气口状态</div>
                <div class="infomation_body">
                  <div>
                    <span class="status_">状态:</span> <span class="value_">{{ ambientHumidity == '' ? '--' : `${ambientHumidity.realData}` }}</span>
                  </div>
                </div>
              </div>
              <div class="center_infomation gk">
                <div class="infomation_head">采集的单次脉冲数</div>
                <div class="infomation_body">
                  <div>
                    <span class="status_">脉冲数:</span> <span class="value_">{{ heatingMedium == '' ? '--' : `${heatingMedium.realData}` }}</span>
                  </div>
                </div>
              </div>
              <div class="center_infomation jrc">
                <div class="infomation_head">单次运动的脉冲数</div>
                <div class="infomation_body">
                  <div>
                    <span class="status_">脉冲数:</span> <span class="value_">{{ binGate == '' ? '--' : `${binGate.realData}` }}</span>
                  </div>
                </div>
              </div>
              <div>
                <img class="center_img_chong" src="../../assets/img/bao.png" alt="" />
              </div>
            </div>
            <div>
              <div class="swiper_title">拍照与识别</div>
              <div class="center">
                <el-carousel :interval="6000" type="card" height="110px" @change="getindex">
                  <el-carousel-item v-for="(item, index) in picList" class="carousel" :key="index">
                    <img :src="item.value" :ref="'child' + index" style="height: 80%; width: auto" />
                    <span class="title_" style="margin: auto; width: auto">
                      {{ item.createDate }}
                    </span>
                  </el-carousel-item>
                  <div class="empty-box3" v-if="empty">
                    <img :src="empty_img" />
                    <p>暂无数据</p>
                  </div>
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="empty">
      <el-empty description="暂无绑定孢子设备" :image-size="200"></el-empty>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    numericalDevices: {}
  },
  data() {
    return {
      chong_value: 0,
      currentPage: 1, //初始页
      pagesize: 6, //    每页的数据
      total: 0, //总数
      picList: [],
      deviceList: [],
      informationList: [],
      showActive: 0,
      numericalDevices: [],
      environmentTemperature: {},
      ambientHumidity: '',
      longitude: [],
      rainGutter: '',
      signal: '',
      lightOperated: '',
      aisle: '',
      heatingMedium: '',
      binGate: '',
      address: '',
      empty: false
    }
  },
  mounted() {
    // this.getHomeMonitorList()
    console.log(this.numericalDevices)
    this.getInfomation()
    if (this.deviceList[index].picDeviceId && this.deviceList[index].imageAttributeId) {
      this.getPicImageList(this.deviceList[index].picDeviceId, this.deviceList[index].imageAttributeId)
    }
  },
  watch: {
    numericalDevices(newVal, old) {
      console.log(this.numericalDevices, 456)

      this.getInfomation()
      if (this.deviceList[index].picDeviceId && this.deviceList[index].imageAttributeId) {
        this.getPicImageList(this.deviceList[index].picDeviceId, this.deviceList[index].imageAttributeId)
      }
    }
  },
  methods: {
    getAll(index) {
      this.showActive = index
      this.numericalDevices = this.deviceList[index].numericalDevices
      this.address = this.deviceList[index].address
      this.numericalDevices.map(item => {
        item.updateTime = this.getHMS(item.updateTime)
      })
      this.getInfomation()
      if (this.deviceList[index].picDeviceId && this.deviceList[index].imageAttributeId) {
        this.getPicImageList(this.deviceList[index].picDeviceId, this.deviceList[index].imageAttributeId)
      }
    },
    getInfomation() {
      this.numericalDevices.numericalDevices.map(item => {
        if (item.attributeName.includes('控制模式')) {
          this.environmentTemperature = item
        } else if (item.attributeName.includes('排气口状态')) {
          this.ambientHumidity = item
        } else if (item.attributeName.includes('采集的累计脉冲数')) {
          this.rainGutter = item
        } else if (item.attributeName.includes('采样口状态')) {
          this.signal = item
        } else if (item.attributeName.includes('吸气口状态')) {
          this.lightOperated = item
        } else if (item.attributeName.includes('采集的单次脉冲数')) {
          this.heatingMedium = item
        } else if (item.attributeName.includes('单次运动距离的脉冲数')) {
          this.binGate = item
        }
      })
    },
    getHomeMonitorList() {
      //获取分组列表
      this.$api.device.getHomeMonitorList({ type: 3 }).then(res => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.empty = true
          } else {
            this.deviceList = res.data
            this.numericalDevices = this.deviceList[0].numericalDevices
            this.address = this.deviceList[0].address
            this.numericalDevices.map(item => {
              item.updateTime = this.getHMS(item.updateTime)
            })
            this.getInfomation()
            this.getPicImageList(res.data[0].picDeviceId, res.data[0].imageAttributeId)
          }
        }
      })
    },
    getHMS(timestamp) {
      var date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '/'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/'
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '

      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    getPicImageList(id, imageAttributeId) {
      this.$api.device
        .getPicImageList(this.currentPage, this.pagesize, id, imageAttributeId)
        .then(res => {
          if (res.code == 200) {
            if (this.currentPage != 1 && res.data.length == 0) {
              this.currentPage = this.currentPage - 1
              //this.getDeviceList();
            } else {
              this.total = res.pageInfo.total
              if (res.data.length == 0) {
                this.empty = true
              } else {
                this.empty = false
              }
              this.picList = res.data
              this.picList.map(item => {
                item.createDate = this.getHMS(item.createDate)
              })
              console.log(this.picList)
            }
          } else {
            this.empty = false
            this.$toaster.error(res.msg)
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
.swiper_title {
  font-size: 18px;
  margin-left: 2rem;
  font-weight: bold;
  color: #2494f2;
}
::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: #cecdcd;
  border-radius: 4px;
}

.big_box {
  display: flex;
  justify-content: space-around;
}
.left_box {
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 10px;
  width: 17%;
  background-color: #ffffff;
  height: 730px;
}
.left_head {
  width: 100%;
  height: 40px;
  line-height: 40px;

  background-color: #2494f2;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.center_head {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  margin-left: 20px;
  color: #2494f2;
  font-weight: bold;
}
.title {
  font-size: 16px;
  margin-left: 20px;
  color: #ffffff;
  font-weight: bold;
}
.left_body {
  height: 660px;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.body {
  cursor: pointer;
  height: 120px;
  display: flex;
  align-items: center;
  margin: 8px;
  border-radius: 20px;
  border: 1px solid #c5c6c7;
  justify-content: center;
}
.active {
  border: 2px solid #9ecbf3;
}
.text {
  margin-top: 1rem;
  font-size: 15px;
  color: #4aaafd;
  margin-left: 10px;
}
.yellow {
  color: #fcb046;
  margin-top: 15px;
  margin-bottom: 20px;
}
.black {
  color: #000;
  font-weight: normal;
}
.alertbox {
  display: flex;
  justify-content: center;
}
.bottom_box {
  width: 100%;
  margin-left: 30px;
  display: flex;
  justify-content: space-between;
}
.bottom_box .el-button.is-round {
  border-radius: 15px !important;
}
.bottom_box .el-button {
  padding: 0px !important;
  text-align: center !important;
  width: 60px !important;
  height: 25px !important;
  line-height: 0px !important;
}

.right_box {
  margin-top: 20px;
  margin-right: 20px;
  border-radius: 10px;
  width: 16%;
  background-color: #ffffff;
  height: 730px;
}
.right_head {
  width: 100%;
  height: 40px;
  line-height: 40px;

  background-color: #2494f2;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.right_body {
  height: 660px;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.right_body .body {
  height: 120px;
  display: flex;
  margin: 8px;
  border-radius: 20px;
  border: 2px solid #9ecbf3;
}

.center_box {
  margin-top: 20px;
  margin-right: 20px;
  border-radius: 10px;
  height: 530px;
  width: 70%;
}
.center_body {
  display: flex;
  height: 100%;
  position: relative;
}
.center_ {
  width: 100%;
}
.center_infomation {
  position: absolute;
  top: 2rem;
  border: 1.5px solid #60bef9;
  border-radius: 10px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5);
}
.gk {
  top: 4rem;
  left: 20rem;
}

.jrc {
  top: 4rem;
  right: 20rem;
}
.td {
  top: 10rem;
  right: 16rem;
}
.cm {
  top: 10rem;
  left: 16rem;
}
.xhtx {
  top: 16rem;
  left: 20rem;
}
.dd {
  top: 16rem;
  right: 20rem;
}
.infomation_head {
  width: 7rem;
  height: 30px;
  line-height: 35px;
  background-color: #2494f2;
  /* border-radius: 5px; */
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: #ffffff;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
}
.ty_head {
}

.infomation_body {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 7rem;
  height: 40px;
  text-align: center;
  font-size: 13px;
}
.jrc_ {
  height: 50px;
}
.status_ {
  color: #999999;
}
.value_ {
  font-weight: bold;
}
.center_img_chong {
  width: 22rem;
  position: relative;
  left: 35%;
  margin-top: 3rem;
}
.center_img {
  width: 100%;
  margin-bottom: 1rem;
  /* background-color: #ffffff; */
  border-radius: 20px;
}

.qi {
  width: 32rem;
  /* height: 50rem; */
  height: 100%;
}
.shui {
  width: 40rem;
  margin-left: 10rem;
  margin-top: 2rem;
}
.center_right {
  margin-left: -1rem;
  height: 100%;
}
.center_right_title {
  margin-left: 1.2rem;
}
.bg_img {
  width: 4.5rem;
}
.center_right_title_ {
  font-size: 17px;
  font-weight: bold;
}
.center_right_img {
  width: 4.8rem;
  margin-left: 1rem;
  margin-top: 0.5rem;
}

.null {
  font-weight: normal;
  font-size: 15px;
  color: #a19ebd;
  margin-top: 0.5rem;
}
.center_rightBoxs {
  margin-top: 2rem;
  margin-left: 3rem;
  width: 16rem;
  height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #09f87c; */
  border-bottom: 1px solid #a19ebd;
}
.center_rightBoxs_q {
  margin-top: 2rem;
  margin-left: 3rem;
  width: 16rem;
  height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #09f87c; */
  border-bottom: 1px solid #a19ebd;
}
.right_body .bottom_box {
  margin-left: 5px;
  align-items: center;
}
.right_body .bottom_box .time {
  margin-left: 5px;
  font-size: 10px;
  font-weight: bold;
}
.right_body .bottom_box .el-button {
  width: 80px !important;
}
.num {
  font-size: 23px;
  color: #000;
  margin-top: 5px;
}
.unit {
  font-size: 14px;
}
.bg_box {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bg_box_img {
  margin-top: 1rem;
}
.body_ {
  margin-left: 10px;
  position: relative;
  width: 100%;
  height: 60%;
  display: flex;
  margin-top: 10px;
}
.arributeTitle {
  width: 150px;
  overflow: hidden;
}
.status {
  position: absolute;
  float: right;
  right: 15px;
  font-weight: bold;
  color: #09f87c;
}
.status1 {
  color: #aaaaaa;
}
.status1 {
  color: red;
}
.selcet {
  width: 225px !important;
  z-index: 99999;
  float: right;
}
.selcet_bo {
  position: absolute;
  right: 15px;
}
.chong_value {
  height: 300px;
  z-index: 9999 !important;
}

.main_box {
  width: 100%;
  height: 100%;
}
.title_ {
  font-size: 14px;
  color: #c5c6c7;
}
.carousel {
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
}
.center_text {
  width: 100%;
  height: 36px;
  font-size: 26px;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #333;
  line-height: 36px;
  /* margin-left: 60px; */
}
</style>
